<template>
	<div class="animated fadeIn">


		<div class="row">
			<div class="col-xs-12">
				<h2>
					<i class="fa fa-fire text-success"></i>
					<span v-show="!carousel.editMode">创建轮播图</span>
					<span v-show="carousel.editMode">编辑轮播图</span>
				</h2>
				<div class="pull-right">
					<CreateSaveButton :entity="carousel" :callback="save"/>
				</div>
			</div>
		</div>


		<div class="row">

			<div class="col-xs-12 m-t-md">

				<div class="form-group">
					<label class="control-label">标题</label>
					<input type="text" class="form-control" v-model="carousel.name">
				</div>

				<div class="form-group">


					<NbCheckbox :val="true" v-model="carousel.showName"/>
					<label class="control-label">图片下方是否显示标题</label>
				</div>


				<div class="form-group clear">
					<img class="thumb-lg pull-left m-r-md">
					<label class="control-label">图片</label>

					<div>
						<NbTank :tank="carousel.image"/>
					</div>

				</div>
				<div class="form-group">
					<label class="control-label">链接</label>
					<input type="text" class="form-control" v-model="carousel.url">
				</div>


			</div>
			<div class="col-xs-12 m-t-md">
				<div class="alert alert-danger" v-show="carousel.errorMessage">
					{{carousel.errorMessage}}
				</div>
				<div class="pull-right">
					<CreateSaveButton :entity="carousel" :callback="save"/>
				</div>
			</div>
		</div>

	</div>

</template>
<script>
	import NbTag from '../../../common/widget/NbTag'
	import NbTank from '../../../common/widget/NbTank'
	import NbEditor from "../../../common/widget/NbEditor"
	import CreateSaveButton from "../widget/CreateSaveButton.vue"
	import NbCheckbox from "../../../common/widget/NbCheckbox.vue"
	import {simpleDateTime, str2Date} from '../../../common/filter/time'
	import {Notification} from 'element-ui';
	import Carousel from '../../../common/model/carousel/Carousel'


	import {getErrorMessage} from '../../../common/util/Utils'
	import $ from "jquery"

	export default {

		data () {
			return {
				carousel: new Carousel()
			}
		},
		components: {
			NbTag,
			NbTank,
			CreateSaveButton,
			NbEditor,
			NbCheckbox
		},
		computed: {},
		watch: {},
		methods: {
			save(){
				let that = this;
				this.carousel.httpSave(function (response) {

					Notification.success({
						message: that.carousel.editMode ? '修改轮播图成功！' : '创建轮播图成功！'
					});
					that.$router.push("/cgd/by/carousel/list");

				});
			}
		},


		mounted(){

			let that = this;

			this.carousel.id = this.$store.state.route.params.id;

			if (this.carousel.id) {

				this.carousel.editMode = true;
				this.carousel.httpDetail();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Create.vue?6b84ec7b